jQuery(document).ready(function ($) {
    function toggleLoadingScreen() {
        $('.loading').fadeToggle(250);
    }

    function getActiveTab() {
        return $('.things-to-do__tab[data-active]');
    }

    $('.things-to-do__tab').on('click', function (event) {
        event.preventDefault();

        const active_tab = getActiveTab();

        if ($(this).attr('data-term-id') !== active_tab.attr('data-term-id')) {
            active_tab.removeAttr('data-active');
            $(this).attr('data-active', '');

            getThingsToDo();
        }
    });

    function getThingsToDo() {
        const active_tab = getActiveTab();

        $.ajax({
            url: things_to_do.ajax_url,
            type: 'POST',
            data: {
                term_id: active_tab.attr('data-term-id'),
                action: 'get_things_to_do',
                nonce: things_to_do.nonce
            },

            beforeSend: function () {
                console.log('getting posts...');
                toggleLoadingScreen();
            },

            success: function (response) {
                $('.things-to-do__content').html(response.data);
            },

            error: function (response) {
                $('.things-to-do__content').html(response.data);
            },

            complete: function () {
                console.log('get_posts complete!');
                toggleLoadingScreen();
            }
        });
    }

    if ($('.things-to-do').length > 0) {
        getThingsToDo();
    }
});